import { Injectable } from '@angular/core';
import { TlkModalWindowService } from '@itero/ui-toolkit-angular/modal-window';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AdditionalInfoIds, AdditionalInfoResult } from '@modules/rx-intuitive-crown-additional-info/models/additional-info';
import { CrownSelectionContext } from '@modules/rx-intuitive-crown/models/crown-models';
import {
	RxIntuitiveAdditionalInfoModalComponent,
	RxIntuitiveAdditionalInfoModalData
} from './rx-intuitive-additional-info-modal.component';

@Injectable({ providedIn: 'root' })
export class RxIntuitiveAdditionalInfoModalService {
	constructor(private readonly modalService: TlkModalWindowService) {}

	open(
		isReadOnly: boolean,
		crownContext: CrownSelectionContext,
		initialValues: AdditionalInfoIds | null,
		shouldValidateForSend: boolean
	): Observable<AdditionalInfoResult | null> {
		const data: RxIntuitiveAdditionalInfoModalData = { isReadOnly, crownContext, initialValues, shouldValidateForSend };

		const dialogRef = this.modalService.open(RxIntuitiveAdditionalInfoModalComponent, {
			panelClass: 'rx-intuitive-additional-info-modal-dialog',
			data,
			autoFocus: true,
			disableClose: true
		});

		return dialogRef.closed.pipe(
			map((result: unknown) => (result != null && typeof result === 'object' ? (result as AdditionalInfoResult) : null))
		);
	}
}
